"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.feedback = void 0;
const plugin_html_multi_response_1 = __importDefault(require("@jspsych-contrib/plugin-html-multi-response"));
const __1 = require("../../..");
const helpers_1 = require("../helpers");
const taskStore_1 = require("../../../taskStore");
// isPractice parameter is for tasks that don't have a corpus (e.g. memory game)
const feedback = (isPractice = false, correctFeedbackAudioKey, inCorrectFeedbackAudioKey, showPrompt = false) => {
    return {
        timeline: [
            {
                type: plugin_html_multi_response_1.default,
                stimulus: () => {
                    const t = (0, taskStore_1.taskStore)().translations;
                    const isCorrect = (0, taskStore_1.taskStore)().isCorrect;
                    const imageUrl = isCorrect ? __1.mediaAssets.images['smilingFace@2x'] : __1.mediaAssets.images['sadFace@2x'];
                    let promptOnIncorrect; // prompt displayed at bottom if incorrect, differs by task
                    switch ((0, taskStore_1.taskStore)().task) {
                        case 'same-different-selection':
                            promptOnIncorrect = t.sds2matchPrompt1;
                            break;
                        case 'memory-game':
                            if (inCorrectFeedbackAudioKey.toUpperCase().includes('BACKWARD')) {
                                promptOnIncorrect = t.memoryGameBackwardPrompt;
                            }
                            else {
                                promptOnIncorrect = t.memoryGameForwardPrompt;
                            }
                            break;
                        case 'egma-math':
                            promptOnIncorrect = t.numberLineSliderPrompt1;
                            break;
                        default:
                            promptOnIncorrect = '';
                    }
                    return `<div class="lev-stimulus-container">
                            <div class="lev-row-container instruction">
                                <p>${isCorrect ? t.feedbackCorrect : t.feedbackNotQuiteRight}</p>
                            </div>
                            <div class="lev-stim-content">
                                <img src=${imageUrl} alt="Image not loading: ${imageUrl}. Please continue the task."'/>
                            </div>
                    
                            ${isCorrect || !showPrompt
                        ? ''
                        : `<div class="lev-row-container instruction"'>
                                <p>${promptOnIncorrect}</p>
                              </div>`}
                        </div>`;
                },
                button_choices: ['Continue'],
                keyboard_choices: 'NO_KEYS',
                prompt_above_buttons: true,
                button_html: () => {
                    const t = (0, taskStore_1.taskStore)().translations;
                    return `<button class="primary">${t.continueButtonText}</button>`;
                },
                on_load: () => {
                    const isCorrect = (0, taskStore_1.taskStore)().isCorrect;
                    const stimulusPath = isCorrect
                        ? __1.mediaAssets.audio[correctFeedbackAudioKey]
                        : __1.mediaAssets.audio[inCorrectFeedbackAudioKey];
                    const audioConfig = {
                        restrictRepetition: {
                            enabled: false,
                            maxRepetitions: 2,
                        },
                    };
                    helpers_1.PageAudioHandler.stopAndDisconnectNode();
                    helpers_1.PageAudioHandler.playAudio(stimulusPath || __1.mediaAssets.audio.nullAudio, audioConfig);
                },
                on_finish: () => {
                    helpers_1.PageAudioHandler.stopAndDisconnectNode();
                },
            },
        ],
        conditional_function: () => {
            var _a, _b;
            return (((_a = (0, taskStore_1.taskStore)().nextStimulus) === null || _a === void 0 ? void 0 : _a.notes) === 'practice' ||
                ((_b = (0, taskStore_1.taskStore)().nextStimulus) === null || _b === void 0 ? void 0 : _b.trialType) === 'practice' ||
                isPractice);
        },
    };
};
exports.feedback = feedback;
